import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";
import { cashnatorFloat } from "../utils/functions";

const CouponsList = ({ coupons, setEdit, setEditableCoupon }) => {

    const handleEdit = (coupon) => {
        setEdit(true);
        setEditableCoupon(coupon);
    }

    const handleQueryCellInfo = (args) => {
        if (args.column.field === "isActive") {
            if (args.data.isActive) {
                args.cell.style.color = "green";
            } else {
                args.cell.style.color = "red";
            }
        }
    };

    return (
        <GridComponent dataSource={coupons} allowSorting allowPaging queryCellInfo={handleQueryCellInfo} pageSettings={{ pageSize: 30 }}>
            <ColumnsDirective>
                <ColumnDirective field='code' headerText="Código" width='100' textAlign="Center" />
                <ColumnDirective field='value' headerText="Valor" width='100' textAlign="Center" valueAccessor={(f, d) => { return d?.kind === "amount" ? cashnatorFloat(d?.value) : `${d?.value}%` }} />
                <ColumnDirective field='kind' width='100' headerText="Tipo" textAlign="Center" valueAccessor={(f, d) => { return d?.kind === "percent" ? "Percentual" : d?.kind === "amount" ? "Quantia" : "" }} />
                <ColumnDirective field='isActive' width='100' headerText="Ativo" textAlign="Center" valueAccessor={(f, d) => { return d?.isActive ? "✔" : "X" }} />
                <ColumnDirective field='timesUsed' width='100' headerText="Utilizações" textAlign="Center" />
                <ColumnDirective width='100' textAlign="Center" template={(d, f) => { return <button onClick={() => handleEdit(d)} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Ver</button> }} />
            </ColumnsDirective>
            <Inject services={[Sort, Page]} />
        </GridComponent>
    )
}

export default CouponsList;
